import { defineMessages } from 'react-intl';

export const scope = 'axionimprovements.features.categories';

export default defineMessages({

    departments: {
        id: `${scope}.labels.departments`,
        defaultMessage: 'Departments.',
    },
    add_category: {
        id: `${scope}.labels.add_category`,
        defaultMessage: 'Add calendar.',
    },
    update_category: {
        id: `${scope}.labels.add_category`,
        defaultMessage: 'Update calendar.',
    },
    delete_category: {
        id: `${scope}.labels.delete_category`,
        defaultMessage: 'Delete calendar.',
    },
    add_a_new_category: {
        id: `${scope}.labels.add_a_new_category`,
        defaultMessage: 'Add a new calendar.',
    },
    update_a_category: {
        id: `${scope}.labels.update_a_category`,
        defaultMessage: 'Update a calendar.',
    },
    could_not_update_category: {
        id: `${scope}.labels.could_not_update_category`,
        defaultMessage: 'Could not update the calendar.',
    },
    could_not_create_category: {
        id: `${scope}.labels.could_not_create_category`,
        defaultMessage: 'Could not create the calendar.',
    },
    could_not_delete_category: {
        id: `${scope}.labels.could_not_delete_category`,
        defaultMessage: 'Could not delete the calendar.',
    },
    edit_category: {
        id: `${scope}.labels.edit_category`,
        defaultMessage: 'Edit the calendar.',
    },
    categories: {
        id: `${scope}.labels.categories`,
        defaultMessage: 'Calendars.',
    },
    topLevelCategories: {
        id: `${scope}.labels.topLevelCategories`,
        defaultMessage: 'Top level calendars.',
    },
    selectTopLevel: {
        id: `${scope}.labels.selectTopLevel`,
        defaultMessage: 'Sum to top level.',
    },
    edit: {
        id: `${scope}.labels.edit`,
        defaultMessage: 'Edit.',
    },
    noneSelected: {
        id: `${scope}.labels.noneSelected`,
        defaultMessage: 'None selected.',
    },
    values: {
        id: `${scope}.labels.values`,
        defaultMessage: 'Values.',
    },
    all_departments: {
        id: `${scope}.labels.all_departments`,
        defaultMessage: 'All departments.',
    },
    name: {
        id: `${scope}.labels.name`,
        defaultMessage: 'Name.',
    },
    btn_close: {
        id: `${scope}.labels.btn_close`,
        defaultMessage: 'Close.',
    },
    select_department: {
        id: `${scope}.labels.select_department`,
        defaultMessage: 'Select department.',
    },
    values_title: {
        id: `${scope}.labels.values_title`,
        defaultMessage: 'Add/Edit values.',
    },
    save: {
        id: `${scope}.labels.save`,
        defaultMessage: 'Save.',
    },
    delete: {
        id: `${scope}.labels.delete`,
        defaultMessage: 'Delete.',
    },
    yes: {
        id: `${scope}.labels.yes`,
        defaultMessage: 'Yes.',
    },
    no: {
        id: `${scope}.labels.no`,
        defaultMessage: 'No.',
    },
    sure_delete_category: {
        id: `${scope}.labels.sure_delete_category`,
        defaultMessage: 'Are you sure you want to delete the calendar?.',
    },
    redIncidents: {
        id: `${scope}.labels.redIncidents`,
        defaultMessage: 'Red incidents',
    },
    orangeIncidents: {
        id: `${scope}.labels.orangeIncidents`,
        defaultMessage: 'Orange incidents',
    },
    yellowIncidents: {
        id: `${scope}.labels.yellowIncidents`,
        defaultMessage: 'Yellow incidents',
    },
    greenIncidents: {
        id: `${scope}.labels.greenIncidents`,
        defaultMessage: 'Green incidents',
    },
    blueIncidents: {
        id: `${scope}.labels.blueIncidents`,
        defaultMessage: 'Remarks',
    },




});